// Internal Dependencies:
import { getStorage, setStorage } from 'utilities/storage'

const userAgent = window.navigator.userAgent.toLowerCase()
const appMode = ( 'standalone' in window.navigator && window.navigator.standalone ) || ( window.matchMedia( '(display-mode: standalone)' ).matches )
// const appMode = true
const isIos = /iphone|ipad|ipod/.test( userAgent )

if ( appMode && 'orientation' in screen ) {
	const screenLocked = screen.orientation.lock( 'natural' )
}

const authHasLoggedInBefore = getStorage( 'auth_has_logged_in_before' )

let isEmbedded = false

try {
	isEmbedded = window.self !== window.top
} catch ( e ) {
	isEmbedded = true
}

const initialState = {
	appMode: appMode,
	isIos: isIos,
	isEmbedded: isEmbedded,
	dismissedInstallAppBanner: siteData.dismissed_install_app_banner,
	hasSeenVotdIntro: siteData.has_seen_votd_intro,
	screenWidth: window.innerWidth,
	screenHeight: window.innerHeight,
	isMobile: window.innerWidth <= siteData.mobile_max_width,
	menuIsOpen: false,
	accountDropdownIsOpen: false,
	hasSidebar: true,
	scrollTopButtonVisibility: false,
	programsPageScrollOffset: window.innerWidth <= siteData.mobile_max_width ? 60 : 110,
	hasScrolledToProgramsPage: false,

	requestedAccountData: false,
	accountData: false,
	loggedIn: false,
	hasLoggedInBefore: authHasLoggedInBefore,
	hasReceivedLikesData: false,
	showLoginNudgeModal: false,
	showLoginNudgeModalType: false,
	showBadgeAwardModal: false,
	programMenu: {
		isOpen: false,
		program: false,
		source: false
	},
	siteNotice: {
		isOpen: false,
		heading: '',
		text: '',
		cancelText: '',
		actions: []
	},
	shareLinkData: false,

	loadedScripts: []
}

if ( appMode ) {
	document.documentElement.classList.add( 'app-mode-html' )
	document.body.classList.add( 'app-mode-body' )
}

export default function reducer( state = initialState, action ) {
	const { payload } = action
	let newLikes,
		newLikesSeries

	switch ( action.type ) {
		case 'GET_SCREEN_SIZE':
			return {
				...state,
				screenWidth: window.innerWidth,
				screenHeight: window.innerHeight,
				isMobile: window.innerWidth <= siteData.mobile_max_width
			}

		case 'OPEN_MENU':
			return {
				...state,
				menuIsOpen: true
			}

		case 'CLOSE_MENU':
			return {
				...state,
				menuIsOpen: false
			}

		case 'CLOSE_ACCOUNT_DROPDOWN':
			return {
				...state,
				accountDropdownIsOpen: false
			}

		case 'TOGGLE_ACCOUNT_DROPDOWN':
			return {
				...state,
				accountDropdownIsOpen: ! state.accountDropdownIsOpen
			}

		case 'SET_SIDEBAR_VISIBILITY':
			return {
				...state,
				hasSidebar: payload
			}

		case 'SET_DISMISSED_INSTALL_WEB_APP_IOS_BANNER':
			return {
				...state,
				dismissedInstallAppBanner: true
			}

		case 'SET_HAS_SEEN_VOTD_INTRO':
			return {
				...state,
				hasSeenVotdIntro: true
			}

		case 'SET_HAS_NOT_SEEN_VOTD_INTRO':
			return {
				...state,
				hasSeenVotdIntro: false
			}

		case 'SET_SCROLL_TOP_BUTTON_VISIBILITY':
			return {
				...state,
				scrollTopButtonVisibility: payload
			}

		case 'SET_HAS_SCROLLED_TO_PROGRAMS_PAGE':
			return {
				...state,
				hasScrolledToProgramsPage: payload
			}

		case 'RECEIVE_ACCOUNT_DATA':
			return {
				...state,
				requestedAccountData: true,
				accountData: payload,
				loggedIn: ( payload && payload.email )
			}

		case 'RECEIVE_ACCOUNT_LIKES_DATA':
			return {
				...state,
				accountData: {
					...state.accountData,
					likes: payload.likes,
					likes_series: payload.likes_series
				}
			}

		case 'RECEIVE_ACCOUNT_LIKES_DATA_PART_B':
			return {
				...state,
				hasReceivedLikesData: true
			}

		case 'RECEIVE_ACCOUNT_DATA_LISTEN_TIME':
			return {
				...state,
				accountData: {
					...state.accountData,
					listen_time_seconds: payload
				}
			}

		case 'RECEIVE_ACCOUNT_DATA_LIKE':
			newLikes = {},
			newLikesSeries = {}

			if ( state.accountData.likes ) {
				newLikes = state.accountData.likes
			}

			if ( state.accountData.likes_series ) {
				newLikesSeries = state.accountData.likes_series
			}

			// If set, remove:
			if ( newLikes[ payload.program.audio_file_url ] && ! newLikes[ payload.program.audio_file_url ].is_removed ) {
				if ( payload.keepInState ) {
					newLikes[ payload.program.audio_file_url ].is_removed = true
				} else {
					delete newLikes[ payload.program.audio_file_url ]

					// Check if series needs removing:
					let seriesHasLikes = Object.keys( state.accountData.likes ).some( key => {
						let item = state.accountData.likes[ key ]

						if ( item.series_slug == payload.program.series_slug ) {
							return true
						}
					} )

					if ( ! seriesHasLikes ) {
						delete newLikesSeries[ payload.program.series_slug ]
					}
				}
			} else {
				newLikes = {
					...newLikes,
					[ payload.program.audio_file_url ]: {
						url: payload.program.audio_file_url,
						title: payload.program.title,
						series_slug: payload.program.series_slug,
						guests: payload.program.guests,
						number: payload.program.number,
						last_played_timestamp_gmt: payload.program.last_played_timestamp_gmt
					}
				}

				newLikesSeries = {
					...newLikesSeries,
					[ payload.program.series_slug ]: payload.program.series
				}
			}

			return {
				...state,
				accountData: {
					...state.accountData,
					likes: newLikes,
					likes_series: newLikesSeries
				}
			}

		case 'CLEANUP_REMOVED_LIKES':
			newLikes = {},
			newLikesSeries = {}

			if ( state.accountData.likes ) {
				newLikes = state.accountData.likes
			}

			if ( state.accountData.likes_series ) {
				newLikesSeries = state.accountData.likes_series
			}

			Object.keys( newLikes ).forEach( key => {
				let item = newLikes[ key ]

				if ( item.is_removed ) {
					delete newLikes[ key ]
				}
			} )

			// Check if any series needs removing:
			Object.keys( newLikesSeries ).forEach( seriesSlug => {
				let seriesHasLikes = Object.keys( newLikes ).some( key => {
					let item = newLikes[ key ]

					if ( item.series_slug == seriesSlug ) {
						return true
					}
				} )

				if ( ! seriesHasLikes ) {
					delete newLikesSeries[ seriesSlug ]
				}
			} )

			return {
				...state,
				accountData: {
					...state.accountData,
					likes: newLikes,
					likes_series: newLikesSeries
				}
			}

		case 'SHOW_LOGIN_NUDGE_MODAL':
			return {
				...state,
				showLoginNudgeModal: payload.state,
				showLoginNudgeModalType: payload.type
			}

		case 'SHOW_BADGE_AWARD_MODAL':
			return {
				...state,
				showBadgeAwardModal: payload
			}

		case 'SHOW_PROGRAM_MENU':
			return {
				...state,
				programMenu: {
					isOpen: true,
					program: payload.program,
					source: payload.source
				}
			}

		case 'HIDE_PROGRAM_MENU':
			return {
				...state,
				programMenu: {
					isOpen: false,
					program: false
				}
			}

		case 'SHOW_SITE_NOTICE':
			return {
				...state,
				siteNotice: {
					isOpen: true,
					heading: payload.heading,
					text: payload.text,
					cancelText: payload.cancelText,
					actions: payload.actions
				}
			}

		case 'HIDE_SITE_NOTICE':
			return {
				...state,
				siteNotice: {
					isOpen: false,
					heading: '',
					text: '',
					cancelText: '',
					actions: []
				}
			}

		case 'RECEIVE_SHARE_LINK_DATA':
			return {
				...state,
				shareLinkData: payload
			}
	}

	return state
}
